var map = {
	"./aebischer.png": 34,
	"./badran.png": 352,
	"./baeumle.png": 717,
	"./barrile.png": 395,
	"./fiala.png": 63,
	"./fischer.png": 772,
	"./glaettli.png": 750,
	"./gredig.png": 600,
	"./gugger.png": 127,
	"./heer.png": 448,
	"./koeppel.png": 118,
	"./marti.png": 111,
	"./matter.png": 907,
	"./meyer.png": 268,
	"./molina.png": 794,
	"./moser.png": 887,
	"./rutz.png": 437,
	"./schaffner.png": 664,
	"./schlaepfer.png": 259,
	"./schneider.png": 569,
	"./silberschmidt.png": 707,
	"./walliser.png": 905,
	"./walti.png": 671
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 351;